<template>
    <Transition name="pop">
        <div class="pop" v-if="show">
            <div class="content">
                <span class="close" @click="show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>活动规则</h1>
                <div class="row">
                    <span>1、</span>
                    <p>活动时间：9月7日-9月10日23:59:59</p>
                </div>
                <div class="row">
                    <span>2、</span>
                    <p>
                        抽奖权限说明：角色需先在【畅享版】新服“乘风破浪-先驱”创建角色，并且在活动页面中完成新区角色绑定，才能解锁抽奖权限。绑定后的角色将无法解除或者更换，预创建了多个角色的玩家需要谨慎绑定角色
                    </p>
                </div>
                <div class="row">
                    <span>3、</span>
                    <div>
                        <h4>根据相应的任务可获得抽奖次数：</h4>
                        <ul>
                            <li>1. 在活动页面绑定角色后加入兄弟团，可+1次</li>
                            <li>2. 兄弟团成员达到3人时，可+1次</li>
                            <li>3. 兄弟团成员达到5人时，可+1次</li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <span>4、</span>
                    <p>
                        游戏道具发放：活动期间，在活动页面获得的所有奖励，可点击我的奖品查看，虚拟道具奖励（除盛趣点券和实物奖励）请于新区开启后，前往天风大陆新区福利使者处领取
                    </p>
                </div>
                <div class="row">
                    <span>5、</span>
                    <p>
                        点券和实物奖励发放：成功抽取盛趣点券/实物奖励的玩家，需要达成：页面绑定角色在9月13日23:59:59前，达成角色达到100级，方可领取；盛趣点券和实物奖励兑换券将在核实角色等级后，统一发放至满足活动要求的玩家账号中
                    </p>
                </div>
                <div class="row">
                    <span>6、</span>
                    <p>同ip下参与抽奖账号最多为3个通行证账户</p>
                </div>
                <div class="row">
                    <span>7、</span>
                    <p>
                        如使用外挂，作弊器及其其他不正当方式参与本次活动，官方将有权取消用户参与资格和已领取的奖励
                    </p>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref } from "vue";

const show = ref(false);

defineExpose({
    Show: () => {
        show.value = true;
    }
});
</script>

<style lang="scss" scoped></style>
